import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { createPortal } from 'react-dom'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { kycStatusCheck, setStage, setSubStage } from '../../../../slices/eligibility/eligibilitySlice';
import Lightbox from "../../../common/LightBox";
import Loader from '../../../common/Loader';

function CommonKyc() {

  const [searchParams] = useSearchParams();
  const referenceId = searchParams.get('referenceId');

  const { kycLink } = useSelector(state => state.eligibility)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [loader, setLoader] = useState(false);
  const [overlay, setOverlay] = useState(false);

  useEffect(() => {
    const handleMessage = (event) => {

      // Handle the KYC callback data - when message is "Callback Sent"
      if (event.data === 'CLOSE_IFRAME') {
        setLoader(true);
        dispatch(
          kycStatusCheck({ reference_id: referenceId })
        ).unwrap().then((res) => {
          setLoader(false);
          if (res.response_code === 'S100') {
            // toast.success(res?.response_string);
            dispatch(setStage("kyc"));
            dispatch(setSubStage("fos_selfie"));
          } else if (res.response_code === 'E320') {
            // Retry the KYC status check if response_code is E320
            setLoader(true);
            dispatch(
              kycStatusCheck({ reference_id: referenceId })
            ).unwrap().then((retryRes) => {
              setLoader(false);
              if (retryRes.response_code === 'S100') {
                dispatch(setStage("kyc"));
                dispatch(setSubStage("fos_selfie"));
              } else {
                toast.error(retryRes?.response_string);
                navigate('/dashboard');
              }
            }).catch(() => {
              setLoader(false);
              toast.error(`Couldn't fetch KYC status`);
            });
          } else {
            toast.error(res?.response_string);
            navigate('/dashboard')
          }
        }).catch((error) => {
          setLoader(false);
          toast.error(`Couldn't fetch KYC status`);
        });
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const handleKycRetrieve = () => {}

  return (
    <>
      {overlay === true && createPortal(<Lightbox stage="kyc" subStage="kyc-in-progress" onRetrieve={handleKycRetrieve} />, document.body)}
      {loader === true && <Loader />}
      <div className="col-md-9 col-sm-12 Side-kyc-Right">
        <iframe style={{ width: "100%" }}
          src={kycLink}
          id="myFrame"
          title="Embedded Application"
          allow="geolocation; microphone; camera"
          className='kyc-iframe'
        />
      </div>
    </>
  )
}

export default CommonKyc